var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e12237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce1126"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v6.095238h-16z",
    fill: "url(#c)",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 6.095238h16v5.333333h-16z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.23705522 1.26239413c-.2072032-.07728893-.43148114-.11953699-.66562665-.11953699-1.05197095 0-1.9047619.85279096-1.9047619 1.90476191s.85279095 1.9047619 1.9047619 1.9047619c.23414551 0 .45842345-.04224805.66562665-.11953699-.3911536.3131878-.88746919.50048937-1.42753141.50048937-1.26236514 0-2.28571429-1.02334914-2.28571429-2.28571428 0-1.26236515 1.02334915-2.28571429 2.28571429-2.28571429.54006222 0 1.03637781.18730158 1.42753141.50048937zm-1.04657903 1.78522492c-.21039419 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055819-.38095238.38095238-.38095238s.38095238.17055819.38095238.38095238c0 .21039418-.17055819.38095238-.38095238.38095238zm.76190476 1.52380952c-.21039418 0-.38095238-.17055819-.38095238-.38095238s.1705582-.38095238.38095238-.38095238c.21039419 0 .38095238.17055819.38095238.38095238s-.17055819.38095238-.38095238.38095238zm1.52380953 0c-.21039419 0-.38095238-.17055819-.38095238-.38095238s.17055819-.38095238.38095238-.38095238c.21039418 0 .38095238.17055819.38095238.38095238s-.1705582.38095238-.38095238.38095238zm.76190476-1.52380952c-.21039419 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055819-.38095238.38095238-.38095238.21039418 0 .38095238.17055819.38095238.38095238 0 .21039418-.1705582.38095238-.38095238.38095238zm-1.52380953-1.14285715c-.21039418 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.1705582-.38095238.38095238-.38095238.21039419 0 .38095239.1705582.38095239.38095238 0 .21039419-.1705582.38095238-.38095239.38095238z",
    mask: "url(#d)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/SG.de344245ffc275527ead2cb9e3338c9b.svg";
export { ForwardRef as ReactComponent };